module.exports = __webpack_public_path__ + "media/img/auth/leader-ec84d9084b100bd90a349f394dcb6c16.png";